module.exports = __webpack_public_path__ + "static/media/ai-sparkle.e6d4928b.svg";